module.exports = __webpack_public_path__ + "img/category_366.7922d4bb.jpg";